import { AZ_QUERY_CONST, PB_QUERY_CONST } from '../../../constants';
import stripQueryKey from './strip-query-key';
const getListQuery = (query, hasListSpecificFilters, name) => {
  const updatedQuery = {};
  const listKey = `${PB_QUERY_CONST}[${name}]`;
  const paginationKey = `${listKey}[page]`;
  const azFilterKey = `${listKey}${AZ_QUERY_CONST}`;
  const sortKey = `${listKey}[sort]`;
  const sortByKey = `${listKey}[sortby]`;
  Object.keys(query).forEach(queryKey => {
    const isListKey = queryKey.indexOf(`${listKey}`) !== -1;
    const decodedQueryValue = Array.isArray(query[queryKey]) ? query[queryKey].map(value => decodeURIComponent(value)) : decodeURIComponent(query[queryKey]);
    if (hasListSpecificFilters) {
      const strippedKey = stripQueryKey(queryKey, listKey, paginationKey);
      if (isListKey) updatedQuery[strippedKey] = decodedQueryValue;
    } else {
      if (queryKey.indexOf(`${PB_QUERY_CONST}[`) === -1) updatedQuery[queryKey] = decodedQueryValue;
      if (queryKey.indexOf(paginationKey) !== -1) updatedQuery[queryKey] = decodedQueryValue;
      if (queryKey.indexOf(azFilterKey) !== -1) updatedQuery[queryKey] = decodedQueryValue;
    }
  });
  updatedQuery.sort = query[sortKey] || query.sort;
  updatedQuery.sortby = query[sortByKey] || query.sortby;
  return updatedQuery;
};
export default getListQuery;
//# sourceMappingURL=get-list-query.js.map